import React, { useState, useEffect } from "react";
import infoImg from "../../assets/images/info.svg";
import profileImg from "../../assets/images/profile.svg";
import "../welcome/welcome.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getCurrentUserProfile } from "../../services/dashboardService";
import { cleanDisplayName, isProfileComplete } from "../../utils/profile";

function DeveloperWelcomeForm() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [studioName, setStudioName] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://backend-dot-immersely-ai.nw.r.appspot.com/api/v1";

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }
    const loadProfile = async () => {
      try {
        const profile = await getCurrentUserProfile();
        if (!profile) {
          return;
        }
        if (isProfileComplete(profile)) {
          navigate("/developer");
          return;
        }
        setStudioName(cleanDisplayName(profile.name) || profile.username || "");
      } catch (error) {
        // Stay on the form if profile cannot be loaded.
      }
    };

    loadProfile();
  }, [navigate, token]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if studio name field is filled
    if (studioName.trim() === "") {
      setSubmitError("Studio name is required.");
      return;
    }

    const formData = {
      name: studioName.trim(),
      username: studioName.trim(),
      role: "developer",
    };

    localStorage.setItem("name", studioName);
    localStorage.setItem("username", studioName);
    setSubmitError("");
    setSubmitting(true);

    axios
      .post(
        `${API_BASE_URL}/profile`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(async () => {
        localStorage.setItem("formSubmitted", "true");
        navigate("/developer");
      })
      .catch((error) => {
        setSubmitError(error.response?.data?.message || "Failed to save studio name. Please try a different name.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const clearForm = () => {
    setStudioName("");
  };

  return (
    <div className="modern-welcome-form-container">
      {/* Animated Background Elements */}
      <div className="background-elements">
        <div className="bg-element bg-element-1"></div>
        <div className="bg-element bg-element-2"></div>
        <div className="bg-element bg-element-3"></div>
      </div>

      <div className="form-content">
        <div className="form-header">
          <img src={infoImg} alt="info" className="header-icon" />
          <img src={profileImg} alt="profile" className="header-icon" />
        </div>
        <div className="form-wrapper">
          <div className="modern-form-card">
            <div className="form-title">WELCOME TO IMMERSELY DEVELOPER PORTAL</div>
            <div className="form-subtitle">
              Please tell us about your studio
            </div>
            <div className="form-fields">
              <div className="field-row">
                <div className="form-group">
                  <span className="required-asterisk">*</span>
                  <input
                    className="modern-input"
                    placeholder="Studio Name"
                    value={studioName}
                    onChange={(e) => setStudioName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              {submitError && (
                <p style={{ color: "#fca5a5", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {submitError}
                </p>
              )}
              <div className="form-buttons">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => clearForm()}
                >
                  CLEAR
                </button>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                  {submitting ? "SAVING..." : "SUBMIT"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeveloperWelcomeForm;






